export default __webpack_public_path__ + "static/media/yd-s3.ea548c54.png";